import React, { useRef, useState, useEffect} from 'react'
import "./Signup.css";
import { Form, Alert } from "react-bootstrap";
import { Button, Spinner } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { signUpUserStart } from '../../../redux/User/user.actions';
import { auth, provider } from '../../../firebase/utils';
import { useHistory, Link } from 'react-router-dom';
import LogoMark from "../../../images/LogoMark.png";
import Header from "../../../components/GreenHeaderSignUp/GreenHeaderSignup";



const myStyle={
  backgroundImage: `url(${LogoMark})`,
  backgroundColor: '#016b37',
  height:'120vh',
  marginTop:'-10px',
  fontSize:'50px',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
};


const Signup = () => {

  const dispatch = useDispatch();
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [password, setPassword] = useState("");
  const [isloading, setLoading] = useState(false);
  const [passtoggle, setPasstoggle] = useState(false);
  const [passtypetoggle, setPasstypetoggle] = useState(false);
  const history = useHistory();

  const [fName, setfName] = useState("");
  const [lName, setlName] = useState("");



  const hidePass = () => {
    setPasstoggle(!passtoggle);
    setPasstypetoggle(!passtypetoggle)
  }


  // const Google = () => {
  //   auth.signInWithPopup(provider)
  //   .then((res)=>{
  //     console.log(res)
  //     setLoading(false);
  //     setTimeout(() => {
  //       history.push('/login');
  //     })
  //    }).catch((err)=>{
  //     console.log(err)
  //    });
  // }

  const handleSubmit = async (e) => {
    
    setLoading(true);
    e.preventDefault();
    setError("");
    auth.fetchSignInMethodsForEmail(email)
    
    
      .then((signInMethods) => {
        if (signInMethods.length) {
          setLoading(false);
          setTimeout(() => {
            setError("User already exists")
          })
          
        } else {
          dispatch(signUpUserStart({
            fName,
            lName,
            email,
            password,
          }));
          setLoading(false);
          setTimeout(() => {
            history.push('/login');
          })
          
        }
        
      })
      
      .catch((err) => {
        console.log(err)
        setError(err.message);
        setLoading(false);
      });
    
  }



  return (
    <>

    <Header/>

      <div style={myStyle}>

          <div className="signUpCont">

          <h1 className="sUP">

          Sign up to the <span>planet</span>

          </h1>

          {error && <div className="error">{error}</div>}
          
            <form className='form' onSubmit={handleSubmit} >

            <div className='label2'><p>First Name*</p></div>
          
          <input type="text" className="signUpEmail" placeholder="Enter your first Name" onChange={(e) => setfName(e.target.value)} required />
  

          <div className='label2'><p>Last Name*</p></div>
          
          <input type="text" className="signUpEmail" placeholder="Enter your Last Name" onChange={(e) => setlName(e.target.value)} required />
  
  
              <div className='label2'><p>Email ID*</p></div>
             
                <input type="email" className='signUpEmail' placeholder="Enter your email" onChange={(e) => setEmail(e.target.value)} required />
                
                
                <div className='label2'><p>Password*</p></div>

                <div className='passwordFlex'>

                <input
                type={passtypetoggle ? 'text' : 'password'}
                name="password"
                value={password}
                minlength="4"
                placeholder="Enter your Password"
                className='signUpPassword'
                onChange={e => setPassword(e.target.value)}
              />
              <div className='visibility-btn' onClick={hidePass}>
                <div className='toggle-Icn'>

                  <i class={passtoggle ? "fa1 fa-eye active" : "fa1 fa-eye" }></i>

                  <i class={passtoggle ? "fa1 fa-eye-slash" : "fa1 fa-eye-slash active"}></i>
                </div>
              </div>
              </div>
          
            <button className="signUpBtn"  >
             {isloading ? <Spinner animation="border" role="status" size="sm" variant="primary" /> : <p>Signup</p>}
           </button>

              {/* <p className='memberr'>I'm already a member? <a href='/'>Login</a></p> */}


            </form>
          </div>

        </div>
      

    </>

  )
}

export default Signup

